export const testimonialData = [
  {
    id: 1,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png1.png",
    avatarAlt: "avatar 1",
    name: "Courtney Henry",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 2,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png2.png",
    avatarAlt: "avatar 2",
    name: "Esther Howard",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 60,
  },
  {
    id: 3,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png4.png",
    avatarAlt: "avatar 3",
    name: "Annette Black",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 4,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png6.png",
    avatarAlt: "avatar 4",
    name: "Bessie Cooper",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 5,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png3.png",
    avatarAlt: "avatar 5",
    name: "Courtney Henry",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 6,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png1.png",
    avatarAlt: "avatar 1",
    name: "Courtney Henry",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 7,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png2.png",
    avatarAlt: "avatar 2",
    name: "Esther Howard",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 60,
  },
  {
    id: 8,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png4.png",
    avatarAlt: "avatar 3",
    name: "Annette Black",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 9,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png6.png",
    avatarAlt: "avatar 4",
    name: "Bessie Cooper",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
  {
    id: 10,
    quote:
      "My experience with property management services has exceeded expectations. They efficiently manage properties with a professional and attentive approach in every situation. I feel reassured that any issue will be resolved promptly and effectively.",
    avatarSrc: "/images/avatar/avt-png3.png",
    avatarAlt: "avatar 5",
    name: "Courtney Henry",
    position: "CEO Themesflat",
    stars: 5,
    avatarSize: 34,
  },
];

export const testimonials = [
  {
    stars: 5,
    text: `"My experience with property management services has exceeded expectations. 
            They efficiently manage properties with a professional and attentive approach 
            in every situation. I feel reassured that any issue will be resolved promptly 
            and effectively."`,
    wowDelay: "0s",
    wowDuration: "1000ms",
    animated: false,
  },
  {
    stars: 5,
    text: `"My experience with property management services has exceeded expectations. 
            They efficiently manage properties with a professional and attentive approach 
            in every situation. I feel reassured that any issue will be resolved promptly 
            and effectively."`,
    wowDelay: "0s",
    wowDuration: "1000ms",
    animated: false,
  },
  {
    stars: 5,
    text: `"My experience with property management services has exceeded expectations. 
            They efficiently manage properties with a professional and attentive approach 
            in every situation. I feel reassured that any issue will be resolved promptly 
            and effectively."`,
    wowDelay: ".2s",
    wowDuration: "2000ms",
    animated: true,
  },
];
